import { Col, Row } from 'reactstrap';

const SummaryWidgetsSkeleton = () => (
    <Row className="g-3 mb-4">
        <Col xs="12" lg="5">
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '112px' }} />
        </Col>
        <Col xs="12" lg="7">
            <Row className="g-3">
                {[1, 2, 3, 4].map((item) => (
                    <Col key={item} xs="12" sm="6" lg="3">
                        <div className="dt-field dt-skeleton" style={{ width: '100%', height: '112px' }} />
                    </Col>
                ))}
            </Row>
        </Col>
    </Row>
);

export default SummaryWidgetsSkeleton;
